import React from 'react'
import styled, { CSSProperties } from 'styled-components'
import Text from './Text'
import { DarkBlue, DarkBlueHover, DarkGray } from '../assets/colors'

const StyledButton = styled.button<{ hoverColor: string, disabledColor: string }>`
  min-width: 100px;
  background-color: ${(props) => props.color};
  color: #fff;
  padding: 4px 16px;
  border-radius: 8px;
  box-shadow: 0px 3px 14px rgba(0, 0, 0, 0.16);
  border: 0;
  cursor: pointer;
  :hover {
    transition: 200ms ease-in-out;
    background-color: ${(props) => props.hoverColor};
  }
  :disabled {
    background: ${(props) =>
    (props.disabledColor ? props.disabledColor : DarkGray)};
    cursor: not-allowed;
  }
`

export type ButtonTypes = 'button' | 'submit' | 'reset'

interface ButtonProps {
  text?: string
  plainText?: string
  onClick?: any
  color?: string
  hoverColor?: string
  style?: CSSProperties
  innerRef?: React.MutableRefObject<HTMLButtonElement>
  type?: ButtonTypes
  className?: string
  isDisabled?: boolean
  disabledColor?: string
  testId?: string
  tabIndex?: number
  id?: string
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void
}

function Button({
  id,
  text,
  plainText,
  onClick = undefined || (() => {}),
  color = DarkBlue,
  hoverColor = DarkBlueHover,
  style = {},
  innerRef = undefined,
  type = 'button',
  className = undefined,
  isDisabled = false,
  disabledColor = '',
  testId = '',
  tabIndex,
  onKeyDown,
}: ButtonProps) {
  return (
    <StyledButton
      id={id}
      className={className}
      type={type}
      onKeyDown={onKeyDown}
      onClick={onClick}
      style={{ ...style }}
      ref={innerRef}
      color={color}
      hoverColor={hoverColor}
      disabled={isDisabled}
      disabledColor={disabledColor}
      data-testid={testId}
      tabIndex={tabIndex}
    >
      <Text text={text} plainText={plainText}/>
    </StyledButton>
  )
}

export default Button
